import { change } from "redux-form";

import { USER_DETAILS_FORMS } from "../../../constants/forms";

export const onChangeExclusions = (exclusions, type) =>
  change(USER_DETAILS_FORMS.SERVICE_EXCLUSIONS, type, exclusions);
